import { DeleteOutlined } from "@ant-design/icons";
import { Popconfirm, Switch, Table, Tag, message } from "antd";
import { useEventAccessUpdateAgentRole } from "features/users/use-cases/event-access-update";
import { useState } from "react";

type updateStatus = {
  Flag: string;
  AgentId: string;
  EventId: string;
  IsActive?: boolean;
};

export const EventAcessAgent = ({ eventAcessData, loadingAccess, agentId, initialAcess, page, size, setPage, setSize }: any) => {
  const { mutate } = useEventAccessUpdateAgentRole();

  // 🔵 Only clicked Switch should show loading
  const [loadingId, setLoadingId] = useState<string | null>(null);

  //  HANDLE SWITCH / DELETE
  const handleAction = (
    record: any,
    action: "update" | "delete",
    newStatus?: boolean
  ) => {
    setLoadingId(record.EventId); // set loader only for this row

    const payload: updateStatus = {
      Flag: action === "update" ? "update_status" : "delete",
      AgentId: agentId,
      EventId: record.EventId,
      ...(action === "update" && { IsActive: newStatus }),
    };

    mutate(payload as any, {
      onSuccess: (res: any) => {
        message.success(res.ResponsMessage);
        initialAcess(); // refresh table
        setLoadingId(null); // remove loader
      },
      onError: () => {
        message.error("Action failed.");
        setLoadingId(null); // remove loader
      },
    });
  };

  // 🔵 TABLE COLUMNS
  const columns = [
    {
      title: "Event Name",
      dataIndex: "EventName",
      key: "EventName",
    },
    {
      title: "Sport Category",
      dataIndex: "CategoryName",
      key: "CategoryName",
    },
    {
      title: "Event Date",
      dataIndex: "EventDate",
      key: "EventDate",
    },
    {
      title: "Assign On",
      dataIndex: "AssignDate",
      key: "AssignDate",
    },
    {
      title: "Status",
      dataIndex: "EventMappingStatus",
      key: "EventMappingStatus",
      render: (value: boolean) =>
        value ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>,
    },
    {
      title: "Action",
      align: "center",
      render: (_: any, record: any) => {
        const isActive = record.EventMappingStatus;
        const isSwitchLoading = loadingId === record.EventId; // check if this row is loading

        return (
          <span style={{ display: "flex", gap: 14, justifyContent: "center", alignItems: "center" }}>
            {/* DELETE BUTTON */}
            <Popconfirm
              title="Are you sure to delete?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => handleAction(record, "delete")}
            >
              <span
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: "#C2BDBD",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                title="remove"
              >
                <DeleteOutlined style={{ color: "white", fontSize: 16 }} />
              </span>
            </Popconfirm>

            {/* SWITCH WITH SINGLE LOADER */}
            <Switch
              checked={isActive}
              loading={isSwitchLoading} // only this switch will show spinner
              onChange={(checked) => handleAction(record, "update", checked)}
              style={{
                backgroundColor: isActive ? "#00C054" : "#ff4d4f",
              }}
            />
          </span>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns as any}
      loading={loadingAccess}
      dataSource={Array.isArray(eventAcessData?.items) ? eventAcessData.items : []}
      rowKey={(row: any) => row.EventId}
      pagination={{
        current: page,
        pageSize: size,
        total: eventAcessData?.total || 0,
        onChange: (p, s) => {
          setPage(p);
          setSize(s);
          initialAcess({ page: p, size: s });
        },
      }}
      style={{ border: "1px solid #E8E8E8", borderRadius: "8px" }}
    />

  );
};
